import { useFormStore } from '@/stores/form'
import router from '@/router'
import lookups from '@/assets/json/clientLookups.json'
import axiosInstance from '@/services'

import { DateTime } from 'luxon'

async function checkPersonInfo() {
  const formStore = useFormStore()
  const serviceTransactionId = router.currentRoute.value.params.serviceId

  const hasBirthAndNationality =
    formStore.form.values.dateOfBirth && formStore.form.values.currentNationalityId

  const isPassport = formStore.form.values.passportNumber && formStore.form.values.passportTypeId

  if (
    isPassport ||
    formStore.form.values.personUnifiedNumber ||
    formStore.form.values.identityNumber
  ) {
    formStore.form.setValues({
      fileDepartmentCode: null,
      fileYear: null,
      fileTypeCode: null,
      fileSeqNo: null
    })
  }

  const isFileType =
    formStore.form.values.fileDepartmentCode &&
    formStore.form.values.fileYear &&
    formStore.form.values.fileTypeCode &&
    formStore.form.values.fileSeqNo

  const newDateOfBirth =
    formStore.form.values.dateOfBirth &&
    DateTime.fromFormat(formStore.form.values.dateOfBirth, 'dd/MM/yyyy').toFormat('yyyy/MM/dd')
  const dataObj = {
    FileModuleId:
      serviceTransactionId == lookups.ServiceTransactions.reportsVisaDetails
        ? lookups.permitCategoryType.visa
        : lookups.permitCategoryType.residency,
    FileDepartmentCode: formStore.form.values.fileDepartmentCode,
    FileYear: formStore.form.values.fileYear,
    FileTypeCode: formStore.form.values.fileTypeCode,
    FileSequance: formStore.form.values.fileSeqNo,
    PassportNumber: formStore.form.values.passportNumber,
    PassportTypeId: formStore.form.values.passportTypeId,
    CountryId: formStore.form.values.currentNationalityId
      ? formStore.form.values.currentNationalityId
      : null,
    DateOfBirth: newDateOfBirth,
    IdentityNumber: formStore.form.values.identityNumber,
    PersonUnifiedNumber: formStore.form.values.personUnifiedNumber
  }

  if (
    hasBirthAndNationality &&
    (isPassport ||
      isFileType ||
      formStore.form.values.personUnifiedNumber ||
      formStore.form.values.identityNumber)
  ) {
    try {
      const result = await axiosInstance.post(
        `/api/guest/requestDetails/draft/checkInputPersonData/${serviceTransactionId}`,
        dataObj
      )
      if (result) {
        const {
          sponsorImmigrationDepartmentId,
          departmentCode,
          year,
          serviceCode,
          sequence,
          serviceId
        } = result
        formStore.form.setValues({
          SponsorDepartmentId: sponsorImmigrationDepartmentId,
          fileDepartmentCode: departmentCode,
          fileYear: year,
          fileTypeCode: serviceCode,
          fileSeqNo: sequence
        })
        const dbRes = await axiosInstance.get('/api/lookup/servicesByServiceId/' + serviceId)
        formStore.extraMap.serviceTransactionDBName = dbRes.find(
          (item) => item.id == result.serviceId
        )?.text
      }
    } catch (error) {
      console.error('checkInputPersonData error: ', error)
    }
  }
}

async function checkIfSponsoredByEstablishment() {
  const formStore = useFormStore()
  const {
    personUnifiedNumber = '',
    passportNumber = '',
    passportTypeId = '',
    identityNumber = '',
    currentNationalityId = ''
  } = formStore.form.values
  const { serviceTransactionId } = formStore.extraMap
  if (![446, 447].includes(serviceTransactionId)) return
  if (
    personUnifiedNumber ||
    identityNumber ||
    (passportNumber && passportTypeId && currentNationalityId)
  ) {
    const res = await axiosInstance.post(`/api/typingCenter/requestDetails/draft/getUserFileInfo`, {
      FileModuleId: serviceTransactionId == 446 ? 2 : 1,
      PassportNumber: passportNumber,
      PassportTypeId: passportTypeId,
      CountryId: passportNumber ? currentNationalityId : null,
      IdentityNumber: identityNumber,
      PersonUnifiedNumber: personUnifiedNumber
    })
    if (!res) return
    const { departmentCode = '', year = '', serviceCode = '', sequence = '' } = res
    formStore.draft.request = {
      ...formStore.draft.request,
      fileDepartmentCode: departmentCode,
      fileYear: year,
      fileTypeCode: serviceCode,
      fileSeqNo: sequence
    }
  }
  userInfoByFileNUmber()
}

async function userInfoByFileNUmber() {
  const formStore = useFormStore()
  const {
    fileDepartmentCode = '',
    fileYear = '',
    fileTypeCode = '',
    fileSeqNo = ''
  } = formStore.form.values
  const { serviceTransactionId } = formStore.extraMap
  if (!fileDepartmentCode || !fileYear || !fileTypeCode || !fileSeqNo) return
  let moduleId = 1
  if (serviceTransactionId == 446) {
    moduleId = 2
    getClosedVisaByFileNumber()
  }
  const res = await axiosInstance.get(`/api/user/usersInfoByUnifiedNumberOrFileNumber`, {
    params: {
      isRequestDetails: true,
      FileStatusId: null,
      moduleId,
      unifiedNumber: null,
      resiServiceCode: fileTypeCode,
      departmentCode: fileDepartmentCode,
      resiYear: fileYear,
      resiSequenceNumber: fileSeqNo
    }
  })
  if (!res) return
  checkIfVirtualSponsorByUniNumOrFileNumber(moduleId)
}

async function getClosedVisaByFileNumber() {
  const formStore = useFormStore()
  const {
    fileDepartmentCode = '',
    fileYear = '',
    fileTypeCode = '',
    fileSeqNo = ''
  } = formStore.form.values
  const res = await axiosInstance.get(`/api/printReport/getClosedVisabyFileNumber`, {
    params: {
      fileTypeCode,
      fileDepartmentCode,
      fileYear,
      fileSeqNo
    }
  })
  if (!res) return
}

async function checkIfVirtualSponsorByUniNumOrFileNumber(moduleId) {
  const formStore = useFormStore()
  const {
    personUnifiedNumber = '',
    fileDepartmentCode = '',
    fileYear = '',
    fileTypeCode = '',
    fileSeqNo = ''
  } = formStore.form.values
  const res = await axiosInstance.get(`/api/user/checkIfVirtualSponsorByUniNumOrFileNumber`, {
    params: {
      unifiedNumber: personUnifiedNumber,
      departmentCode: fileDepartmentCode,
      resiYear: fileYear,
      resiServiceCode: fileTypeCode,
      resiSequenceNumber: fileSeqNo,
      moduleId
    }
  })
  if (!res) return
  formStore.extraMap.hideSponsorInformation = false
  if (res.isVirtualSponsor) {
    formStore.extraMap.hideSponsorInformation = true
  }
}

function requestDetailsCurrentNationalityChange(params) {
  const formStore = useFormStore()
  const { applicantIdentityNumber = '' } = formStore.form.values
  const {
    sponsorType: { diplomatic }
  } = lookups
  formStore.form.setFieldValue('sponsorIdentityNumber', '')
  formStore.extraMap.isSponsorIdentityNumber = false
  if (params.id !== diplomatic && !params.isEstablishmentSponsor) {
    formStore.form.setFieldValue('sponsorIdentityNumber', applicantIdentityNumber)
    formStore.extraMap.isSponsorIdentityNumber = true
  }
}
export default function () {
  return {
    checkPersonInfo,
    checkIfSponsoredByEstablishment,
    requestDetailsCurrentNationalityChange
  }
}
